var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33B1E3",
    d: "M6.216 47.563a41.537 41.537 0 1 0 83.074 0 41.537 41.537 0 0 0-83.074 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M34.065 67.295v-22.5h-8.75l22.5-17 22.5 17h-8.75v22.5h-7.5v-8.75a3.75 3.75 0 0 0-3.75-3.75h-5a3.75 3.75 0 0 0-3.75 3.75v8.75z"
  })));
};
export default SvgHome;